import { CmsObjectWithDefault } from '@components/Cms/types';
import { SessionModalCms } from '@apis/model/SessionPackage/SessionModalConfig';
import { useTranslation } from '@contexts/translation/hooks/useTranslation';

export type SessionPackageCmsKey =
    | 'SessionModalHeader'
    | 'SessionModalTitle'
    | 'SessionModalDescription'
    | 'SessionModalContinueButton'
    | 'SessionModalEndButton'
    | 'SessionModalTimeMinWithSecs'
    | 'SessionModalTimeSecs';

export const SessionPackageCmsWithDefault: CmsObjectWithDefault<SessionPackageCmsKey> = {
    SessionModalHeader: {
        cmsId: 224008,
        defaultTranslation: 'Session Time-out',
    },
    SessionModalTitle: {
        cmsId: 224009,
        defaultTranslation: 'Due to inactivities your session will expire in: {0}',
    },
    SessionModalDescription: {
        cmsId: 224181,
        defaultTranslation:
            'If additional time is required, please click "Continue Session". To allow the session to end, click "End"',
    },
    SessionModalContinueButton: {
        cmsId: 224010,
        defaultTranslation: 'Continue Session',
    },
    SessionModalEndButton: {
        cmsId: 224011,
        defaultTranslation: 'End Session',
    },
    SessionModalTimeMinWithSecs: {
        cmsId: 224182,
        defaultTranslation: '{0} minute(s) and {1} second(s)',
    },
    SessionModalTimeSecs: {
        cmsId: 224182,
        defaultTranslation: '{0} second(s)',
    },
};

export const GetSessionModalCms = (): SessionModalCms => {
    const translation = useTranslation(SessionPackageCmsWithDefault);
    return {
        header: translation.SessionModalHeader,
        title: translation.SessionModalTitle,
        description: translation.SessionModalDescription,
        continueButton: translation.SessionModalContinueButton,
        endButton: translation.SessionModalEndButton,
        timeMinWithSecs: translation.SessionModalTimeMinWithSecs,
        timeSecs: translation.SessionModalTimeSecs,
    };
};
